<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top  :subnav_show="false" :change_color="true" :cart_change="cart_change"></shop-top></div>
        <div v-for="(v,k) in header" :key="k">
        <div style="margin:0 auto; text-align: center;" v-if="v.banner">
            <!-- {{ filePath + v.banner }} -->
            <!-- <el-image :src="filePath + v.banner"></el-image> -->
            
            <el-image :src="filePath + v.banner">
                <div slot="error" class="image-slot">
                    <!-- <i class="el-icon-picture-outline"></i> -->
                </div>
            </el-image>
            
        </div>
        <div class="mbx width_center_1200">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <!-- <el-breadcrumb-item><a href="special/">专题列表</a></el-breadcrumb-item> -->
                <el-breadcrumb-item>{{v.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        </div>

        <div class="goods_list width_center_1200">

           
            <div class="goods_list_item" v-for="(v,k) in list" :key="k">

                <dl v-if="v.selltype != 3">
                <router-link :to="'/goods/info/'+v.id" target="_blank">
                <img v-if="v.groupsName != '' && v.groupsName != null && v.groupsName[0].groupsImg !=null" :src="filePath + v.groupsName[0].groupsImg" class="tag" />
                <dt v-if="v.img"><img :src="filePath + v.img" :alt="v.name" :title="v.name"></dt>
                <dt v-else><img src="/pc/nopic.png" :alt="v.name" :title="v.name"></dt>
                <!-- <dt v-else><el-image></el-image></dt> -->
                <dd class="p-icons">
                 <i v-for="(vo,key) in v.groupsName" :key="key" :class="'goods-icons'+ vo.id +' goods-icons J-picon-tips J-picon-fix'">{{vo.name}}</i>
                 <i v-if="show" class="goods-icons1 goods-icons J-picon-tips J-picon-fix'">下单返现</i>
                </dd>
                <dd class="title" :title="v.name">{{v.name}}</dd>
                <dd class="ftitle" :title="v.name">{{v.company_name}}</dd>
                <dd class="parameter">规格:{{v.spec}}</dd>
                <dd class="parameter" v-if="v.exp=='9999-12-30T16:00:00.000+00:00'">效期:-</dd>
                <dd class="parameter" v-else>效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.stock > 200">库存:充足</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                    <dd class="price" v-if="v.is_ControlSales == false">授权查看</dd>
                    <dd class="price" v-else-if="v.price == null && v.nowprice == null" :title="会员可见">会员可见</dd>
                    <dd class="price" v-else-if="v.nowprice == null && v.price != null">￥{{v.price}}</dd>
                    <dd class="price" v-else :title="v.price">￥{{v.nowprice}}<span>￥{{v.price}}</span></dd>
                     </router-link>

                    <dd  class="item-operate">
                    <div class="num-operate">
                        <span class="num-subtract" @click="change_buy_num(v,false)">-</span>
                        <input v-model="v.max" v-enter-number type="text" @on-change="changenum(v)" class="j_num" @change="changenum(v)">
                        <span class="num-add" @click="change_buy_num(v,true)">+</span>
                    </div>
                    <div @click="add_cart(v)" class="j_addCart addcart">加入购物车</div>
                    </dd>
                    <!-- <dd><span class="buy">立即购买</span><span class="evaluate">{{v.comment_count}} 人评价</span></dd> -->
                </dl>
            </div>
            
        </div>
        

        
        

        <!-- <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>暂无获取到相对应数据！
        </div> -->

        <div class="home_fy_block  width_center_1200">

            <!-- <el-pagination background layout="prev, pager, next,jumper,total" :total="total" :pageSize="pageSize" :pageNum="pageNum"></el-pagination> -->

<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :pageSize="pageSize" :pageNum="pageNum"></el-pagination>

        </div>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
<el-dialog
  class="dialog"
  :visible.sync="dialogVisible"
  :show-close="false"
  custom-class="hongbao_class">
	<div class="redbag" @click="hontbaoType='1';handleViews(1)" :class="hontbaoType=='1'?'shake':''">
        <img v-if="redbag.img" :src="filePath + redbag.img">
        <img v-else src="/pc/asd23.png">
        
        </div>
</el-dialog>


    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"

import {formatDate} from '@/utils/date';

export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar,
    },
    props: {},
    data() {
      return {
          list:[],
          groupsName:[],
          groupsImg:null,
          header:[],
          redbag:[], //红包信息
          total:null,
          props:{
              value:'id',
              label:'name',
              checkStrictly:true,
          },
          info:{
          },
          pageSize:20,
          pageNum:1,
          cart_change:0,
          dialogVisible:false,
          hontbaoType:0,
          timeObj:null,
          usebegin:null, //红包开始时间
          useend:null,   //红包结束时间
      };
    },
    watch: {
    },
    computed: {},

    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },

    methods: {
        //红包
        handleViews:function(){
            this.getHongBaoSend();
            setTimeout(()=>{
                this.hontbaoType = 0;
            },2000);
            
        },

        // 商品列表
        getList:function(){ 
            //this.$get(this.$api.getSpecialGoodsById,this.info).then(res=>{
             this.$get(this.$api.getSpecialGoodsById,{subjectId:this.specialid,pageSize:this.pageSize,pageNum:this.pageNum}).then(res=>{
                this.list = res.data.list[0].indexGoodsParamList;
                this.total = res.data.list[0].count;
                document.title = res.data.list[0].title;
                this.header = res.data.list;
                this.pageNum = res.data.list[0].pageNum;
                for (var i = 0; i < this.list.length; i++) {
                       this.list[i].max = res.data.list[0].indexGoodsParamList[i].mini_qty;
                    // }
                }
                // this.groupsImg = res.data.list[0].groupsName[0].groupsImg;
                // this.timeObj = setInterval(()=>{
                //     this.getShowHongBaoBySubId(this.$route.params.info);
                // },30000);
                this.getShowHongBaoBySubId();

            });
        },

        //获取红包信息
        getShowHongBaoBySubId:function(){
             this.$get(this.$api.showHongBaoBySubId,{subjectId:this.specialid}).then(res=>{
                 if(res.code == 200){
                     if(res.data){
                         if(res.data[0]){
                            this.redbag = res.data[0];
                            let nowDdate = Math.floor(new Date().getTime() / 1000);
                            let beginDate = Math.floor(new Date(res.data[0].usebegin).getTime() / 1000);
                            let endDate = Math.floor(new Date(res.data[0].useend).getTime() / 1000);
                            if(beginDate >= nowDdate ){
                                this.dialogVisible = true;
                            }else if(endDate >= nowDdate){
                                this.dialogVisible = true;
                            }else{
                                // clearInterval(this.timeObj);
                                this.dialogVisible = false;
                            }
                         }else{
                             this.redbag.img = null;
                         }

                     }else{
                         this.redbag.img = null;
                     }
                 }

            });
        },
        
        //领取红包
        getHongBaoSend:function(){
             this.$get(this.$api.HongBaoSend,{hongbaoId:this.redbag.id}).then(res=>{
                 if(res.code == 200){
                    setTimeout(()=>{
                        this.getHongBaoReceiveResults();
                    },1500);
                 }else{
                   this.$dialog.error(res.message);
              }
            });
        },

        //红包领取结果
        getHongBaoReceiveResults:function(){
             this.$get(this.$api.HongBaoReceiveResults).then(res=>{
                 if(res.code == 200){
                    setTimeout(()=>{
                     this.dialogVisible = false;
                     this.$message.success(res.data);
                    },1500);
                 }else{
                     this.$message.error(res.message);
                 }
            });
        },


        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        // 分页改变
        current_change:function(e){
            this.pageNum = e;
            this.getList();
            this.$scrollTo();
        },


        // 购买数量修改
        change_buy_num:function(e,type){
            if(type){
                if(e.max +1 > e.stock){
                    return this.$message.error('库存不足');
                }
                e.max += e.mini_qty;
            }else{
                if(e.max <= e.mini_qty){
                    return this.$message.error('最低购买数量为 '+ e.mini_qty);
                }
                e.max -= e.mini_qty;
            }
        },

         changenum:function(e){
            if(e.max <= e.mini_qty){
                e.max = e.mini_qty
            }else{
                if(e.max < e.stock){
                    if(Math.round(e.max / e.stock) <= 1){
                        e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                    }else{
                        e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                    }
                }else if(e.max > e.stock){
                        if(Math.round(e.max / e.stock) < 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty + e.mini_qty
                        }else if(Math.round(e.max / e.stock) == 1){
                            e.max = Math.ceil(e.stock / e.mini_qty) * e.mini_qty
                        }else{
                            e.max = (Math.ceil(e.stock / e.mini_qty)-1) * e.mini_qty
                        }
                }else{
                        if(Math.ceil(e.max / e.mini_qty) * e.mini_qty > e.stock){
                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty - e.mini_qty
                        }else if(Math.ceil(e.max / e.mini_qty) * e.mini_qty == e.stock){
                            e.max = e.stock
                        }else{
                            e.max = Math.ceil(e.max / e.mini_qty) * e.mini_qty
                        }
                }
            }
        },

        // 加入购物车
        add_cart:function(e){
            let date1 = Math.floor(new Date().getTime() / 1000);
            let date2 = Math.floor(new Date(e.exp).getTime() / 1000);
            if(date2-date1 <= '31104000' && e.exp != null ){
                this.$confirm("该商品为近效期商品, 是否继续?", "提示", {
                // this.$confirm('"该商品为近效期商品"+this.expDate+", 是否继续?"'+this.expDate, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                        if(e.max == null){
                            return this.$message.error('购买数量不正确');
                        }else if(e.max <= e.stock ){
                        this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.max,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}]}).then(res=>{
                            if(res.code == 200){
                                if(res.data=='加入购物车成功'){
                                    this.getList();
                                    this.get_cart_count();
                                    this.cart_change += 1; // 修改购物车数据
                                    return this.$message.success('加入购物车成功');
                                }
                                else{
                                    return this.$message.error(res.data);
                                }
                            }else if(res.code == 500){
                                if(res.message=='请登录'){
                                    this.$message.error('请先登录！');
                                    return this.$router.push('/user/login');
                                }else{
                                    return this.$message.error('加入购物车失败'); 
                                }
                            }else{
                                return this.$message.error(res.message);
                            }
                        });  
                        }else{
                            return this.$message.error('库存不足');
                            //this.diasabledInput = true
                        }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                    });
            }else{
                        if(e.max == null){
                            return this.$message.error('购买数量不正确');
                        }else if(e.max <= e.stock ){
                        this.$post(this.$api.homeAddCart,{"rows":[{goodsId:e.id,curPrice:e.curPrice,qty:e.max,platId:this.$platId,companyId:e.companyId,operId:null,promoId:null,promoPrice:e.promoPrice}]}).then(res=>{
                            if(res.code == 200){
                                if(res.data=='加入购物车成功'){
                                    this.getList();
                                    this.get_cart_count();
                                    this.cart_change += 1; // 修改购物车数据
                                    return this.$message.success('加入购物车成功');
                                }
                                else{
                                    return this.$message.error(res.data);
                                }
                            }else if(res.code == 500){
                                if(res.message=='请登录'){
                                    this.$message.error('请先登录！');
                                    return this.$router.push('/user/login');
                                }else{
                                    return this.$message.error('加入购物车失败'); 
                                }
                            }else{
                                return this.$message.error(res.message);
                            }
                        });  
                        }else{
                            return this.$message.error('库存不足');
                            //this.diasabledInput = true
                        } 
            }


            // setTimeout(()=>{
            //     this.diasabledInput=false 
            // },2000);

        },

        get_cart_count:function(){
            this.$get(this.$api.homeGetCartCount,{platId:this.$platId}).then(res=>{
                this.cart_change = res.data
            });
        },

    },

    created() {
        this.filepath();
        this.specialid = this.$route.params.info;
        if(this.$isEmpty(this.specialid)){
            return this.$message.error('请检查专题是否存在');
        }
        this.getList();
        this.getShowHongBaoBySubId();
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_index{
    background: #fff;
}
.goods_sort_top{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.mbx{
    margin:20px auto;
}
.goods_where{
    border:1px solid #efefef;
    background: #fff;
    line-height: 50px;
    font-size: 14px;
    .goods_cat_list,.home_goods_cat_list{
        border-bottom: 1px solid #efefef;
        padding-left:20px; 
        height: 50px;
        line-height: 50px;
        .goods_cat_title{
            float: left;
            margin-right: 20px;
            height: 50px;
            line-height: 50px;
        }
        ul{
            float: left;
        }
        ul.goods_sort_ul{
            li{
                margin-right: 30px;
            }
        }
        ul li{
            float: left;
            color:#666;
            margin-right: 20px;
            a{
                color:#666;
            }
            a:hover{
                color:#409EFF;
            }
        }
        li:hover{
            color:#409EFF;
        }
        ul li.font_color{
            color:#409EFF;
        }
        
    }
    .goods_cat_list:after{
        content:'';
        clear:both;
        display: block;
    }
    .goods_cat_list:last-child{
        border-bottom: none;
    }
}
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 445px;
        box-sizing: border-box;
        margin: 0 20px 20px 0;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 445px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 20px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:20px auto 20px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 194px;
        }
        dl .parameter{
            font-size: 14px;
            color:#666666;
            line-height: 22px;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            // float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #409EFF;
        // }
        // dl dd span{
        //     width: 50%;
        //     display: block;
        //     // border-top: 1px solid #efefef;
        //     float: left;
        //     line-height: 20px;
        //     text-align: left;
        // }
    }
    .goods_list_item:nth-child(5n){
        margin-right: 0;
    }
    // .goods_list_item:hover{
    //     // border:1px solid #409EFF;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
.goods_list_item a:hover .title{
	color:#409EFF;
}
}
</style>
<style>
.p-icons #1{
    background: #e23a3a;
}
.tag{
    position: absolute;
    text-align: right;
    float: right;
    width: 223px;
    height: 223px;
    z-index: 9;
}
</style>

<style>
@keyframes shake{
	0% {
		-webkit-transform: rotate(2deg) translate3d(0,0,0)
	}

	50% {
		-webkit-transform: rotate(-2deg) translate3d(0,0,0)
	}

	100% {
		-webkit-transform: rotate(2deg) translate3d(0,0,0)
	}
}
@-webkit-keyframes shake {
	0% {
		-webkit-transform: rotate(2deg) translate3d(0,0,0)
	}

	50% {
		-webkit-transform: rotate(-2deg) translate3d(0,0,0)
	}

	100% {
		-webkit-transform: rotate(2deg) translate3d(0,0,0)
	}
}

@-moz-keyframes shake {
	0% {
		transform: rotate(2deg) translate3d(0,0,0)
	}

	50% {
		transform: rotate(-2deg) translate3d(0,0,0)
	}

	100% {
		transform: rotate(2deg) translate3d(0,0,0)
	}
}

@-ms-keyframes shake {
	0% {
		transform: rotate(2deg) translate3d(0,0,0)
	}

	50% {
		transform: rotate(-2deg) translate3d(0,0,0)
	}

	100% {
		transform: rotate(2deg) translate3d(0,0,0)
	}
}

.redbag{
	width: 300px;
	height: 345px;
	border-radius: 15px;
	box-shadow: 1px 1px 20px #666;
	position: fixed;
	top:50%;
	left: 50%;
	overflow: hidden;
	margin-left: -150px;
	margin-top: -172px;
	transform-origin: 50% 100%;
	-webkit-transform-origin: 50% 100%;
    cursor: pointer;
}
.redbag img{
	width:100%;
	height: auto;
}
.redbag.shake{
	animation:shake .2s infinite linear;
	-webkit-animation:shake .2s infinite linear;
}

</style>

<style scoped>
.dialog .el-dialog {
    width: 300px !important;
    height: 450px;
}
.dialog .el-dialog__header {
    padding: 0px !important;
}
.dialog .el-dialog__body{
  padding: 0px !important;
}
.dialog .el-dialog__title{
  display: none;
}
.dialog .el-dialog__headerbtn {
    position: absolute;
    top: 170px;
    right: 10px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
    background: none;
    width: 30px;
    height: 30px;
    z-index: 999;
}
.dialog .el-dialog__headerbtn i{
    color: #fff;
}
</style>